/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import { RepositoryFactory } from '../api/RepositoryFactory';
import store from './store';
import Helper from '../helpers/methods/helpers';
import router from '../router.js';

import { cache } from '../../config.json';

const UserCalls = RepositoryFactory.get('user');
const ComapaniesCalls = RepositoryFactory.get('companies');
const ClientsCalls = RepositoryFactory.get('clients');
const LocationCalls = RepositoryFactory.get('locations');
const AppointmentCalls = RepositoryFactory.get('appointments');
const NewsCalls = RepositoryFactory.get('news');
const HcfCalls = RepositoryFactory.get('hcf');
const CodelistCalls = RepositoryFactory.get('codelist');
const GalleryCalls = RepositoryFactory.get('gallery');
const CreditCalls = RepositoryFactory.get('credit');
const CaptchaCalls = RepositoryFactory.get('captcha');

const actions = {
    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////

    updateSidebarWidth({ commit }, width) {
        commit('UPDATE_SIDEBAR_WIDTH', width);
    },
    updateI18nLocale({ commit }, locale) {
        commit('UPDATE_I18N_LOCALE', locale);
    },
    toggleContentOverlay({ commit }) {
        commit('TOGGLE_CONTENT_OVERLAY');
    },
    updateTheme({ commit }, val) {
        commit('UPDATE_THEME', val);
    },
    updateUserRole({ commit }, val) {
        commit('UPDATE_USER_ROLE', val);
    },
    updateWindowWidth({ commit }, width) {
        commit('UPDATE_WINDOW_WIDTH', width);
    },

    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
        commit('UPDATE_STARRED_PAGE', payload);
    },

    //  The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
        commit('ARRANGE_STARRED_PAGES_LIMITED', list);
    },
    arrangeStarredPagesMore({ commit }, list) {
        commit('ARRANGE_STARRED_PAGES_MORE', list);
    },

    //UPDATE LANGUAGE

    //API CALLS
    //GLOBAL
    getInitData({ commit, dispatch, state, getters }) {
        return new Promise((res, rej) => {
            // commit('UPDATE_CACHE', {
            //   res: "getInitData",
            //   time: 1
            // })
            return Promise.all([
                dispatch('updateCurrentUser'),
                dispatch('updateLanguages'),
                dispatch('updateCurrentCompanies'),
                dispatch('updateCurrentClients'),
                dispatch('updateCurrentLocations'),
                dispatch('updateCurrentNews'),
                dispatch('updateCurrentAppointments'),
                dispatch('updateHcfText'),
                dispatch('updateHcfCodelist'),
            ])
                .then(() => {
                    res();
                })
                .catch(() => {});
        });
    },
    //USER DATA
    updateCurrentUser({ commit }) {
        return new Promise((resolve, reject) => {
            UserCalls.getUserInfo(Helper.tokenObj())
                .then(({ data }) => {
                    commit('UPDATE_USER', data);
                    commit('UPDATE_CACHE', {
                        res: 'updateCurrentUser',
                        time: cache.userInfo,
                    });

                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                    window.location.replace('/login');
                });
        });
    },

    //COMPANIES
    updateCurrentCompanies({ commit }) {
        return new Promise((resolve, reject) => {
            ComapaniesCalls.getAllCompanies(Helper.tokenObj())
                .then(({ data }) => {
                    commit('UPDATE_COMPANIES', data);
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    //CLIENTS
    updateCurrentClients({ commit }) {
        return new Promise((resolve, reject) => {
            ClientsCalls.getAllClients(Helper.tokenObj())
                .then(({ data }) => {
                    commit('UPDATE_CLIENTS', data);
                    commit('UPDATE_CACHE', {
                        res: 'updateCurrentClients',
                        time: cache.locationsRelated,
                    });
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    //LOCATIONS
    updateCurrentLocations({ commit }) {
        return new Promise((resolve, reject) => {
            LocationCalls.getAllLocations(Helper.tokenObj())
                .then(({ data }) => {
                    commit('UPDATE_LOCATIONS', data);
                    commit('UPDATE_CACHE', {
                        res: 'updateCurrentLocations',
                        time: cache.locationsRelated,
                    });
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    //LOCATION STUFF
    updateLocationRelated({ commit, dispatch }) {
        return new Promise((res, rej) => {
            commit('UPDATE_CACHE', {
                res: 'getInitData',
                time: cache.locationsRelated,
            });
            return Promise.all([dispatch('updateCurrentCompanies'), dispatch('updateCurrentClients'), dispatch('updateCurrentLocations')]).then(() => res());
        });
    },
    //APPOINTMENTS
    updateCurrentAppointments({ commit }) {
        return new Promise((resolve, reject) => {
            AppointmentCalls.getAllAppointments(Helper.tokenObj())
                .then(({ data }) => {
                    commit('UPDATE_APPOINTMENTS', data);
                    commit('UPDATE_CACHE', {
                        res: 'updateCurrentAppointments',
                        time: cache.locationsRelated,
                    });

                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    //NEWS
    updateCurrentNews({ commit }) {
        return new Promise((resolve, reject) => {
            NewsCalls.getAllNews(Helper.tokenObj())
                .then(({ data }) => {
                    commit('UPDATE_NEWS', data);
                    commit('UPDATE_CACHE', {
                        res: 'updateCurrentNews',
                        time: cache.locationsRelated,
                    });
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    //HCFS
    updateHcfText({ commit }) {
        return new Promise((resolve, reject) => {
            HcfCalls.getHcfText(Helper.tokenObj())
                .then(({ data }) => {
                    commit('UPDATE_HCF', data);
                    commit('UPDATE_CACHE', {
                        res: 'updateHcfText',
                        time: cache.hcf,
                    });
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    //CODELISTS
    updateCurrentCodelist({ commit }, payload) {
        return new Promise((resolve, reject) => {
            CodelistCalls.getCodelistsByType(payload)
                .then((data) => {
                    commit('UPDATE_CODELISTS', {
                        data,
                        payload,
                    });
                    commit('UPDATE_CACHE', {
                        res: `updateCurrentCodelist${payload}`,
                        time: cache.codelists,
                    });
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    /**
     * !GET CREDIT
     */

    updateCurrentCredits({ commit }) {
        return new Promise((resolve, reject) => {
            CreditCalls.getAllCredits(Helper.tokenObj()).then(({ data }) => {
                commit('UPDATE_CREDITS', data);
                commit('UPDATE_CACHE', {
                    res: `updateCurrentCredits`,
                    time: cache.credits,
                });
                resolve();
            });
        });
    },

    updateHcfCodelist({ commit }) {
        return new Promise((resolve, reject) => {
            HcfCalls.getHcfCodelist(Helper.tokenObj())
                .then(({ data }) => {
                    commit('UPDATE_HCF_CODELIST', data);
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    //LOGA XDENT
    updateXdentLogos({ state }, payload) {
        return new Promise((res, rej) => {
            const need = payload.filter((loc) => {
                if (loc && loc.idLogo) {
                    const file = Object.keys(state.userData.AppActiveFiles).find((f) => f === loc.idLogo);
                    if (!file) {
                        return loc.idLogo;
                    }
                }
            });
            if (need.length) {
                Promise.all(
                    need.map((n) => {
                        store.dispatch('updateFileXdentLogoId', n.idLogo);
                    })
                ).then(() => res());
            } else res();
        });
    },

    updateFileXdentLogoId({ commit }, payload) {
        return new Promise((resolve, reject) => {
            LocationCalls.getLocactionLogoByLocationLogoId(payload, Helper.tokenObj())
                .then(({ data }) => {
                    commit('UPDATE_FILE_IDS', {
                        idFile: payload,
                        base: data,
                    });
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    //NOVINKY OBRAZKY
    updateIKlientNewsFileIds({ state }, { payload, isPreview }) {
        const newsFiles = [];
        isPreview ? payload.forEach((n) => n.imagePreviewId && newsFiles.push(n.imagePreviewId)) : payload.forEach((n) => newsFiles.push([...n.imageFilesIds]));
        return new Promise((res, rej) => {
            const need = newsFiles.filter((imgId) => {
                const file = Object.keys(state.userData.AppActiveFiles).find((f) => f === imgId);
                if (!file) {
                    return imgId;
                }
            });
            if (need.length) {
                Promise.all(
                    need.map((n) => {
                        store.dispatch('updateIKlientNewsImgs', n);
                    })
                ).then(() => res());
            } else res();
        });
    },
    updateIKlientNewsImgs({ commit }, payload) {
        return new Promise((resolve, reject) => {
            NewsCalls.getNewsThumbnailByFileId(payload, Helper.tokenObj())
                .then(({ data }) => {
                    commit('UPDATE_FILE_IDS', {
                        idFile: payload,
                        base: data,
                    });
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    /**
     * * This method updates current cached files
     * ! Not for xdent logos and new thumbnails
     * ? Good?
     * @param payload could be array/ string and will be cast to array
     */

    updateFileIds({ state, dispatch }, payload) {
        let imgIds = [];
        if (!payload) {
            return;
        }
        if (typeof payload == 'string') {
            imgIds = [payload];
        } else {
            imgIds = payload;
        }
        return new Promise((res, rej) => {
            const need = imgIds.filter((imgId) => {
                const file = Object.keys(state.userData.AppActiveFiles).find((f) => f === imgId);
                if (!file) {
                    return imgId;
                }
            });
            if (need.length) {
                Promise.all(
                    need.map((n) => {
                        dispatch('updateFileId', n);
                    })
                ).then(() => res());
            } else res();
        });
    },
    // FILE
    updateFileId({ commit }, payload) {
        return new Promise((resolve, reject) => {
            GalleryCalls.getFileContentById(payload, false, Helper.tokenObj())
                .then(({ data }) => {
                    commit('UPDATE_FILE_IDS', {
                        idFile: payload,
                        base: data,
                    });
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    updateLanguages({ commit }, payload) {
        UserCalls.getLanguages(Helper.tokenObj()).then((data) => {
            commit('UPDATE_LANGUAGES', data);
            commit('UPDATE_CACHE', {
                res: `updateLanguages`,
                time: cache.languages,
            });
        });
    },

    updateLanguage({ commit }, payload) {
        UserCalls.changeLanguage(payload.idLanguage, Helper.tokenObj()).then(({ data }) => {
            commit('UPDATE_LANGUAGE', payload);
        });
    },

    /**
     * * This action resets store
     * TODO: Maybe iterate and replace
     */
    resetStore({ commit }, payload) {
        commit('RESET_STORE');
    },

    /**
     * SET RESTRICTION FOR SMS
     */
    updateRestricted({ commit }) {
        commit('UPDATE_RESTRICTED');
    },
    updateSiteKey({ commit }) {
        return new Promise((resolve, reject) => {
            CaptchaCalls.getSiteKey().then(({ data }) => {
                commit('UPDATE_SITEKEY', data);
                resolve(data);
            });
        });
    },

    /**
     * ! CALENDAR ACTIONS // NOT IMPORTANT NOW
     */

    addEventToCalendar({ commit }, event) {
        commit('ADD_EVENT_TO_CALENDAR', event);
    },
    ediCalendarEvent({ commit }, event) {
        commit('EDIT_CALENDAR_EVENT', event);
    },
    removeCalendarEvent({ commit }, eventId) {
        commit('REMOVE_CALENDAR_EVENT', eventId);
    },

    // Simple Calendar Actions
    addEventToSimpleCalendar({ commit }, event) {
        commit('ADD_EVENT_TO_SIMPLE_CALENDAR', event);
    },
    editSimpleCalendarEvent({ commit }, event) {
        commit('EDIT_SIMPLE_CALENDAR_EVENT', event);
    },
    removeSimpleCalendarEvent({ commit }, eventId) {
        commit('REMOVE_SIMPLE_CALENDAR_EVENT', eventId);
    },
    simpleCalendarEventDragged({ commit }, payload) {
        commit('SIMPLE_CALENDAR_EVENT_DRAGGED', payload);
    },
};

export default actions;
